import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import uuid from "shortid";
import { reduxForm } from "redux-form";
import {
  InputField,
  ReactSelectField,
  wrapDialog,
  InfoHelper,
  tgFormValues
} from "@teselagen/ui";
import { compose } from "redux";
import { Button, Intent, Classes } from "@blueprintjs/core";
import { flatMap } from "lodash-es";
import classNames from "classnames";
import withEditorProps from "../../withEditorProps";
import { CheckboxField } from "@teselagen/ui";
import "./style.css";
class MergeFeaturesDialog extends React.Component {
  render() {
    const {
      // editorName,
      hideModal,
      handleSubmit,
      selectedAnnotations,
      sequenceData,
      selectionLayerUpdate,
      id1,
      upsertFeature,
      deleteFeature,
      upsertPrimer,
      deletePrimer,
      id2,
      change
    } = this.props;
    const firstSelectedId = selectedAnnotations.idStack[0];
    const firstSelectedAnn = selectedAnnotations.idMap[firstSelectedId];
    const type = (firstSelectedAnn && firstSelectedAnn.annotationTypePlural) === "primers" ? "primers" : "features";
    const annotations = sequenceData[type] || {};
    const feat1 = annotations[id1];
    const feat2 = annotations[id2];
    const [id1default, id2default] = flatMap(
      selectedAnnotations.idStack,
      (id) => {
        const ann = selectedAnnotations.idMap[id];
        if (ann.annotationTypePlural === type) {
          return id;
        }
        return [];
      }
    );
    const annotationSingular = type === "primers" ? "Primer" : "Feature";
    return /* @__PURE__ */ jsxs(
      "form",
      {
        onSubmit: handleSubmit(
          ({ id1: id12, id2: id22, name, preserveFeatures, start, end }) => {
            const deleteAction = type === "primers" ? deletePrimer : deleteFeature;
            const upsertAction = type === "primers" ? upsertPrimer : upsertFeature;
            if (!preserveFeatures) {
              deleteAction([id12, id22], {
                batchUndoStart: true
              });
            }
            upsertAction(
              {
                ...feat1,
                id: uuid(),
                start: start - 1,
                end: end - 1,
                name
              },
              {
                batchUndoEnd: true
              }
            );
            selectionLayerUpdate({
              start: start - 1,
              end: end - 1
            });
            hideModal();
          }
        ),
        className: classNames(
          Classes.DIALOG_BODY,
          "tg-min-width-dialog",
          "veMergeFeaturesDialog"
        ),
        children: [
          /* @__PURE__ */ jsx(InfoHelper, { displayToSide: true, children: /* @__PURE__ */ jsx("span", { style: { fontStyle: "italic", fontSize: 11, marginTop: -8 }, children: "Choose features in the dropdown or shift click directly on the plasmid map" }) }),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx(
            ReactSelectField,
            {
              inlineLabel: true,
              required: true,
              defaultValue: id1default,
              enableReinitialize: true,
              name: "id1",
              label: /* @__PURE__ */ jsxs("div", { style: { display: "flex", width: "100%", alignItems: "top" }, children: [
                /* @__PURE__ */ jsx(
                  InfoHelper,
                  {
                    ...{
                      popoverProps: {
                        position: "top"
                      }
                    },
                    onClick: () => {
                      feat1 && change("name", feat1.name);
                    },
                    disabled: !feat1,
                    icon: "small-plus",
                    isButton: true,
                    children: "Use Name"
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { padding: "10px 0px 0px 10px", minWidth: 80 }, children: [
                  annotationSingular,
                  " 1:"
                ] })
              ] }),
              options: flatMap(annotations, (feat) => {
                if (feat.id === (feat2 && feat2.id)) return [];
                return {
                  value: feat.id,
                  label: feat.name
                };
              })
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                marginTop: -8,
                marginBottom: 10,
                display: "flex",
                justifyContent: "center",
                width: " 100%"
              },
              children: [
                /* @__PURE__ */ jsxs(
                  Button,
                  {
                    onClick: () => {
                      const id1Holder = id1;
                      change("id1", id2);
                      change("id2", id1Holder);
                    },
                    icon: "swap-vertical",
                    children: [
                      " ",
                      "Swap",
                      " "
                    ]
                  }
                ),
                " ",
                "\xA0",
                " "
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            ReactSelectField,
            {
              inlineLabel: true,
              required: true,
              defaultValue: id2default,
              enableReinitialize: true,
              name: "id2",
              label: /* @__PURE__ */ jsxs("div", { style: { display: "flex", width: "100%", alignItems: "top" }, children: [
                /* @__PURE__ */ jsx(
                  InfoHelper,
                  {
                    onClick: () => {
                      feat2 && change("name", feat2.name);
                    },
                    disabled: !feat2,
                    icon: "small-plus",
                    isButton: true,
                    children: "Use Name"
                  }
                ),
                /* @__PURE__ */ jsxs("div", { style: { padding: "10px 0px 0px 10px", minWidth: 80 }, children: [
                  annotationSingular,
                  " 2:"
                ] })
              ] }),
              options: flatMap(annotations, (feat) => {
                if (feat.id === (feat1 && feat1.id)) return [];
                return {
                  value: feat.id,
                  label: feat.name
                };
              })
            }
          ),
          /* @__PURE__ */ jsx(
            InputField,
            {
              autoFocus: true,
              inlineLabel: true,
              enableReinitialize: true,
              defaultValue: feat1 && feat1.name,
              validate: required,
              name: "name",
              label: "New Name:"
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
            /* @__PURE__ */ jsx(
              InputField,
              {
                inlineLabel: true,
                disabled: true,
                enableReinitialize: true,
                defaultValue: !feat1 ? "" : feat1.start + 1,
                validate: required,
                name: "start",
                label: "New Start:"
              }
            ),
            "\xA0 \xA0 \xA0",
            /* @__PURE__ */ jsx(
              InputField,
              {
                inlineLabel: true,
                disabled: true,
                enableReinitialize: true,
                defaultValue: !feat2 ? "" : feat2.end + 1,
                validate: required,
                name: "end",
                label: "New End:"
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            CheckboxField,
            {
              name: "preserveFeatures",
              defaultValue: false,
              label: `Preserve ${type} (by default they will be removed once merged)`
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: { display: "flex", justifyContent: "flex-end" },
              className: "width100",
              children: /* @__PURE__ */ jsxs(Button, { type: "submit", intent: Intent.PRIMARY, children: [
                "Create Merged ",
                annotationSingular
              ] })
            }
          )
        ]
      }
    );
  }
}
function required(val) {
  if (!val) return "Required";
}
export default compose(
  wrapDialog({
    title: "Merge Features/Primers",
    isDraggable: true,
    width: 400
  }),
  withEditorProps,
  reduxForm({
    form: "MergeFeaturesDialog",
    validate: ({ id1, id2 }) => {
      const errors = {};
      if (!id1 || Array.isArray(id1)) {
        errors.id1 = "Please select a feature";
      }
      if (!id2 || Array.isArray(id2)) {
        errors.id2 = "Please select a feature";
      }
      return errors;
    }
  }),
  tgFormValues("id1", "id2")
)(MergeFeaturesDialog);
